export default __webpack_public_path__ + "static/media/apvs-material-5.e7b8bdc2.webp";